import { ZoneContextProvider } from 'context/ZoneContext';
import ZoneMap from '../ZoneMap';
import MapTour from 'pages/Map/components/MapTour';
import { useIsMobile } from 'hooks';
import { useRegionContext } from 'context/RegionContext';
import { useMapOpenEvents } from '../ZoneMap/hooks/useMapEvents';
import LinkNotFound from '../LinkNotFound';

/**
 * MapRenderer component takes region and renders zone maps
 */
export const MapRenderer = () => {
    const isMobile = useIsMobile();
    const { currentZone } = useRegionContext();
    useMapOpenEvents();

    if (!currentZone) {
        return <LinkNotFound />;
    }

    return (
        <ZoneContextProvider key={currentZone.name}>
            <ZoneMap />
            {!isMobile ? <MapTour /> : null}
        </ZoneContextProvider>
    );
};

MapRenderer.displayName = 'MapRenderer';
